<template>
    <div :class="braintreeDropInWrapperClass">
        <div ref="containerId" />
        <button v-if="!hideSubmitButton" v-on:click="handleSubmit"
                :disabled="isSubmitButtonDisabled"
                :class="submitButtonClasses">
            {{submitButtonText}}
        </button>
    </div>
</template>
<script>
    import braintree from 'braintree-web-drop-in';
    export default {
        name: 'braintree-dropin',
        props: {
            containerId: {
                type: String,
                required: true
            },
            createTransaction: {
                type: Function,
                required: true
            },
            options: {
                type: Object,
                required: true
            },
            threeDSecureParams: {
                type: Object,
                required: true
            },

            hideSubmitButton: {
                type: Boolean,
                default: true
            },
            submitButtonText: {
                type: String,
                default: 'Pay'
            },
            submitButtonClasses: {
                type: String,
                default: 'btn btn-primary'
            },
            braintreeDropInWrapperClass: String,

            createToken: Function,
            onCreate: Function,
            onError: Function,
            onDestroyStart: Function,
            onDestroyEnd: Function,
            onPaymentMethodRequestable: Function,
            onNoPaymentMethodRequestable: Function,

            clearPaymentMethod: {
                type: Boolean,
                default: false
            }
        },
        data: () => {
            return {
                dropInInstance: null,
                isSubmitButtonDisabled: true,
                nonce: null
            }
        },
        watch:{
            clearPaymentMethod : function(val) {
                //console.log('clearPaymentMethod: ', val)
                if (val == true && this.dropInInstance) {
                    this.dropInInstance.clearSelectedPaymentMethod()
                }
            }
        },
        methods: {
            async init(token) {
                const options = {
                    ...this.options,
                    authorization: token,
                    container: this.$refs.containerId
                }
                braintree.create(options, (err, dropinInstance) => {
                    if (err) {
                        if (this.onError) {
                            this.onError(err)
                        }
                        return
                    } else {
                        if (this.onCreate) {
                            this.onCreate(dropinInstance)
                        }
                    }
                    // if (dropinInstance.isPaymentMethodRequestable()) {
                    //     this.isSubmitButtonDisabled = false
                    // }
                    dropinInstance.on('paymentMethodRequestable', (event) => {
                        
                        this.isSubmitButtonDisabled = false
                        if (this.onPaymentMethodRequestable) {
                            this.onPaymentMethodRequestable()
                        }
                        this.$emit('payment-method-requestable')
                         //this.isSubmitButtonDisabled = true;
                        
                        // if (dropinInstance.isPaymentMethodRequestable()) {
                        //     this.dropInInstance.requestPaymentMethod({threeDSecure: this.threeDSecureParams}, async (err, payload) => {
                        //         console.log('this.dropInInstance.requestPaymentMethod')
                        //         if (err) {
                        //             if (this.onError) {
                        //                 this.onError(err)
                        //             }
                        //             this.$emit('payment-method-request-error', err)
                        //         } else {
                        //             this.nonce = payload
                        //             this.$emit('payment-method-request-success', payload)
                        //         }
                        //     })
                        // }
                    })
                    dropinInstance.on('noPaymentMethodRequestable', () => {
                        //this.isSubmitButtonDisabled = true
                        if (this.onNoPaymentMethodRequestable) {
                            this.onNoPaymentMethodRequestable()
                        }
                        this.$emit('no-payment-method-requestable')
                        this.nonce = null
                    })

                    dropinInstance.on('paymentOptionSelected', (evt) => {
                        console.log('paymentOptionSelected: ', evt)
                    })
                    this.dropInInstance = dropinInstance;
                })
            },
            async handleSubmit(event) {
                if (this.dropInInstance && !this.isSubmitButtonDisabled) {
                    this.isSubmitButtonDisabled = true;
                    if (this.dropInInstance.isPaymentMethodRequestable()) {
                            this.dropInInstance.requestPaymentMethod({threeDSecure: this.threeDSecureParams}, async (err, payload) => {
                                
                                if (err) {
                                    if (this.onError) {
                                        this.onError(err)
                                    }
                                    this.$emit('payment-method-request-error', err)
                                } else {
                                    this.isSubmitButtonDisabled = true;
                                    this.nonce = payload
                                    this.$emit('payment-method-request-success', payload)
                                }
                            })
                        }
                }
            },
            async cleardown() {
                if (this.onDestroyStart) {
                    await this.onDestroyStart()
                }
                return new Promise((resolve, reject) => {
                    this.dropInInstance.teardown(async (err) => {
                        if (this.onDestroyEnd) {
                            return await this.onDestroyEnd(err)
                        }
                        if (err) {
                            return reject(err)
                        } else {
                            return resolve()
                        }
                    })
                })
            }
        },
        async mounted() {
            if (this.dropInInstance) return;
            this.init(await this.createToken());
        },
        beforeDestroy() {
            if (!this.dropInInstance) return;
            this.cleardown().catch((err) => {
                if (this.onError) {
                    this.onError(err)
                }
            })
        }
    }
</script>